import { useCallback } from 'react';
import { isPast, subSeconds } from 'date-fns';
import { getExpirationDate, getToken, setToken } from '@e2m-customer-portal/core';
import { useAuthClient } from '../use-auth-client/use-auth-client';
import { useAuth } from '../use-auth/use-auth';

const sentinelSeconds = 10;

export function useAuthenticatedFetch(): typeof fetch {
  const client = useAuthClient();
  const { login } = useAuth();

  return useCallback(
    async (info, init) => {
      const tokenData = getToken();
      if (!tokenData) {
        throw new Error('No access token available.');
      }

      let token = tokenData.access_token;
      if (isPast(subSeconds(getExpirationDate(tokenData.access_token), sentinelSeconds))) {
        if (isPast(subSeconds(getExpirationDate(tokenData.refresh_token), sentinelSeconds))) {
          login();
          throw new Error('Redirecting to login.');
        }

        const oauthToken = client.createToken(tokenData.access_token, tokenData.refresh_token, {});
        const newToken = await oauthToken.refresh();
        setToken({
          ...tokenData,
          access_token: newToken.data.access_token,
          refresh_token: newToken.data.refresh_token,
        });
        token = newToken.data.access_token;
      }

      const options = {
        ...init,
        headers: {
          ...init?.headers,
          Authorization: `Bearer ${token}`,
        },
      };

      return fetch(info, options);
    },
    [client, login],
  );
}
